export default {
    menu: {
        translations: 'Translations',
    },
    graph: {
        'field-name': 'Field name',
        seed: {
            header: 'Seed from payload',
            tooltip: 'Optional. Seeded data is not saved — it is re-derived from the payload on every render, and edits to it are lost on reload.',
            nodes: 'Nodes expression',
            'nodes-tooltip': 'Resolves to a list of items. An item\'s "key" picks the node kind it is drawn from; the rest of the item is what that kind\'s field templates resolve their expressions against. An item whose key matches no node kind is skipped silently.',
            edges: 'Relationships expression',
            'edges-tooltip': 'Resolves to a list of items. An item\'s "key" picks the relationship it is drawn from; the rest of the item is what that relationship\'s field templates resolve their expressions against. An item whose key matches no relationship is skipped silently.',
            missing: 'Nothing will be seeded for {details}',
            'missing-node-id': 'node kinds without a node id expression: {kinds}',
            'missing-edge-ends': 'relationships without both end expressions: {relationships}',
        },
        nodes: {
            header: 'Node kinds',
            add: 'Add node kind',
            remove: 'Remove node kind',
            unnamed: '(unnamed)',
            duplicated: 'Node keys must be unique within a graph. Duplicated: {keys}',
        },
        edges: {
            header: 'Relationships',
            add: 'Add relationship',
            remove: 'Remove relationship',
            unknown: 'Relationships point at unknown node kinds: {keys}',
        },
        node: {
            key: 'Node kind key',
            'key-tooltip': 'Identifies this node kind — relationships reference it, and seeded payload items pick it by this value. Never shown to an end user. Renaming it breaks every relationship that points at it.',
            'key-duplicated': 'Another node kind in this graph already uses this key',
            'key-renamed': '{count} relationship still points at "{key}" — update it too | {count} relationships still point at "{key}" — update them too',
            label: 'Node kind label',
            'label-tooltip': 'What the reader sees on the card. Optional — the key is drawn when it is empty. May interpolate the node\'s own data, e.g. #{name}.',
            'node-id': 'Node id expression',
            'node-id-tooltip': 'Evaluated against one seeded payload item, e.g. {example}. Its result is the node\'s identity — what a relationship\'s end expressions have to resolve to. Only needed when the graph is seeded from the payload.',
        },
        edge: {
            from: 'From node kind',
            to: 'To node kind',
            unknown: 'No node kind in this graph has the key "{key}"',
            key: 'Relationship key',
            'key-tooltip': 'Identifies this relationship, and is the literal path segment a drawn relation is saved under. It must be unique, cannot contain "." "[" "]" and cannot be a number.',
            label: 'Relationship label',
            'label-tooltip': 'What the reader sees on the arrow. Optional — the key is drawn when it is empty. May interpolate the relationship\'s own data, e.g. #{share}%.',
            direction: 'Direction',
            'direction-tooltip': 'How the arrow between the two ends is drawn.',
            'direction-option': {
                FORWARD: 'Forward — arrow points at the "to" kind',
                BACKWARD: 'Backward — arrow points at the "from" kind',
                BIDIRECTIONAL: 'Bidirectional — arrows on both ends',
                NONE: 'None — a plain line, no arrows',
            },
            'from-expression': 'From node id expression',
            'to-expression': 'To node id expression',
            'end-expression-tooltip': 'Evaluated against one seeded payload item, e.g. {example}. Unlike the node kinds above, each must resolve to a node id — whatever that kind\'s node id expression produced. An end that matches no seeded node drops the relationship.',
        },
    },
    translations: {
        title: 'Translations',
        search: 'Search custom page names',
        languages: 'Languages',
        'no-pages': 'This workflow has no custom pages yet.',
        'no-matches': 'No custom pages match the search.',
        field: 'Field',
        source: 'source',
        changed: 'no changes | {count} changed field | {count} changed fields',
        export: 'Export',
        import: 'Import',
        'import-report': {
            summary: 'Matched {matched} fields, {changed} values changed.',
            skipped: 'no rows skipped | {count} row skipped | {count} rows skipped',
            blocked: {
                'invalid-json': 'This file is not valid JSON.',
                'invalid-format': 'This file is not a translations export.',
                'workflow-mismatch': 'This file was exported from a different workflow.',
                'stale-export': 'This file no longer matches the workflow. Saving the workflow after an export makes the file unusable — export the translations again and redo the changes in the new file.',
            },
            error: {
                'not-found': 'the field {fieldPath} no longer exists',
                'source-changed': 'the source text changed since the export ("{sourceText}" → "{currentText}")',
            },
            warning: {
                'default-language-changed': 'The source language changed from {from} to {to} since the export.',
                'unsupported-languages': 'The file contains languages that are not on the supported list: {languages}.',
                'missing-from-file': 'no fields missing | {count} field is not in the file and was left untouched | {count} fields are not in the file and were left untouched',
            },
        },
    },
}
